import { observer } from "mobx-react-lite";

import { InputParameterBuilder } from "./ParameterBuilders/InputParameterBuilder";
import { DropdownParameterBuilder } from "./ParameterBuilders/DropdownBuilder";
import { SliderParameterBuilder } from "./ParameterBuilders/SliderParameterBuilder";
import { GroupParameterBuilder } from "./ParameterBuilders/GroupBuilder";
import { ParameterContentProps } from "./types";

import { ComponentType } from "@/queries/models/types";

const ParameterContentComponent = ({ parameter, isViewing }: ParameterContentProps) => {
  switch (parameter.componentType) {
    case ComponentType.INPUT:
      return <InputParameterBuilder isViewing={isViewing} parameter={parameter} />;
    case ComponentType.DROPDOWN:
      return <DropdownParameterBuilder isViewing={isViewing} parameter={parameter} />;
    case ComponentType.SLIDER:
      return <SliderParameterBuilder isViewing={isViewing} parameter={parameter} />;
    case ComponentType.GROUP:
      return <GroupParameterBuilder isViewing={isViewing} parameter={parameter} />;
    default:
      return null;
  }
};

export const ParameterContent = observer(ParameterContentComponent);
